import { render, staticRenderFns } from "./CustomTextArea.vue?vue&type=template&id=5c65e1a2&scoped=true"
import script from "./CustomTextArea.vue?vue&type=script&lang=js"
export * from "./CustomTextArea.vue?vue&type=script&lang=js"
import style0 from "./CustomTextArea.vue?vue&type=style&index=0&id=5c65e1a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65e1a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c65e1a2')) {
      api.createRecord('5c65e1a2', component.options)
    } else {
      api.reload('5c65e1a2', component.options)
    }
    module.hot.accept("./CustomTextArea.vue?vue&type=template&id=5c65e1a2&scoped=true", function () {
      api.rerender('5c65e1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form/CustomTextArea.vue"
export default component.exports